import { Project, RendererType, Settings, Theme } from '@marketertechnologies/property-picker';

import requestInstance from '~/utils/requestInstance';

type Published = {
  apiPublished: boolean;
  portalPublished: boolean;
};

export type PropertyExplorerProjectData = Published & {
  settings: Settings;
  theme: Theme;
  rendererType: RendererType;
  project: Project & Published;
};

export const getPropertyExplorerProjectData = async (projectUuid: string) => {
  try {
    if (!projectUuid) {
      return Promise.reject(`Missing projectUuid, ${projectUuid}`);
    }

    const response = requestInstance.get<PropertyExplorerProjectData>(
      `/property_pickers/${projectUuid}/data`,
    );

    return (await response).data;
  } catch (e) {
    return Promise.reject(e);
  }
};
